import React, { useState, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import Modal from "react-bootstrap/Modal";
import {
  seleccionarCampo,
  formatMoneda,
  validaMonto,
  round,
  formatoMonto,
} from "../../util/varios";
import * as XLSX from "xlsx";
import useTableScroll from "../useTableScroll";
import moment from "moment";

export const OperacionInvPorExcel = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const organizacion = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const fechaSistema = moment(
    JSON.parse(sessionStorage.getItem("fechasistema")),
  ).format("YYYY-MM-DD");
  const txtCosto = useRef([]);
  const txtPrecio = useRef([]);
  const btnIncluir = useRef();
  const btnCancela = useRef();
  const txtAlmacen = useRef();
  const [habilitadoBot, setHabilitadoBot] = useState(true);
  const [activate, setActivate] = useState(false);
  const [jsonData, setJsonData] = useState([]);
  const [almacenData, setAlmacenData] = useState([]);
  const [productosData, setProductosData] = useState([]);
  const [file, setFile] = useState(null);
  const [body, setBody] = useState(null);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    { label: "CODIGO", textAlign: "center", width: "0px" },
    { label: "DESCRIPCION", textAlign: "center" },
    { label: "PRECIO VENTA", textAlign: "center" },
    { label: "CANTD CAJA/BULTO...", textAlign: "center" },
    { label: "CANTD UNIDADES/L/G...", textAlign: "center" },
    {
      label: <i className="fas fa-trash" />,
      textAlign: "center",
      width: "20px",
    },
  ];

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const seleccionarRegistros = async () => {
    let campos =
      "idalmacen, trim(descripcion) as descripcion, trim(responsable) as responsable, ventas";
    let nomtab = "almacen";
    let orden = "idalmacen";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setAlmacenData(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarRegistrosProductos = async () => {
    let campos =
      "idproducto, idunidadmedida, idunidadalterna, codigo, valorfactor";
    let nomtab = "producto";
    let orden = "idproducto";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setProductosData(response.data);
          } else {
            setProductosData([]);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/inventario/actualizaropeinv/${1}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto:
              "registro " + response.data.idopeinv + " creado correctamente",
            icono: "exito",
          });
          window.open(
            op.reportes +
              `/almacen?afiliado=${organizacion}&reporte=ReporteDetaOpeInventario&codigo=${response.data.idopeinv}`,
            "Planilla",
            "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
          );
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          mensaje = error.response.data.message;
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const validarCosto = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let data = [...jsonData];
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", "."),
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length,
        );
      }
      let canti = parseFloat(
        event.target.value.replace(/\./g, "").replace(",", "."),
      );

      data[index].cantidadc = canti;
      setJsonData(data);
    }
  };

  const validarPrecio = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      let data = [...jsonData];
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", "."),
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length,
        );
      }
      let canti = parseFloat(
        event.target.value.replace(/\./g, "").replace(",", "."),
      );

      data[index].cantidadu = canti;
      setJsonData(data);
    }
  };

  const eliminarProducto = (producto) => (e) => {
    e.preventDefault();
    let data = [...jsonData];
    let elementos = [];

    for (let i = 0; i < data.length; i++) {
      if (producto.codigo !== data[i].codigo) {
        elementos.push(data[i]);
      }
    }
    setJsonData(elementos);
  };

  const onChangeValidar = () => {
    var opeinv = [];
    var opeinvdet = [];

    opeinv.push({
      idoperacioninventario: 0,
      tipooperacion: "INGRESO",
      idalmacenorigen: txtAlmacen.current.value,
      idalmacendestino: "",
      fecha: fechaSistema,
      idmoneda: props.idmoney,
      observacion: "INGRESO EXISTENCIA DESDE ARCHIVO EXCEL",
    });

    for (let i = 0; i < jsonData.length; i++) {
      if (
        jsonData[i].idproducto !== null &&
        (parseFloat(jsonData[i].cantidadc) > 0 ||
          parseFloat(jsonData[i].cantidadu) > 0)
      ) {
        let canti = 0.0;
        let tipo = null;
        if (
          parseFloat(jsonData[i].cantidadc) > 0 &&
          parseFloat(jsonData[i].cantidadu) > 0
        ) {
          canti =
            parseFloat(jsonData[i].cantidadc) *
              parseFloat(jsonData[i].valorfactor) +
            parseFloat(jsonData[i].cantidadu);
          tipo = 1;
        } else {
          if (jsonData[i].cantidadc > 0 && jsonData[i].cantidadu <= 0) {
            canti = jsonData[i].cantidadc;
            tipo = 0;
          } else if (jsonData[i].cantidadc <= 0 && jsonData[i].cantidadu > 0) {
            canti = jsonData[i].cantidadu;
            tipo = 1;
          }
        }

        opeinvdet.push({
          idproducto: jsonData[i].idproducto,
          nombre: jsonData[i].nombrecorto,
          cantidad: canti,
          precio: jsonData[i].precioventa,
          fechavencimiento: null,
          tipomovimiento: "INVENTARIO INICIAL",
          fechatipomovimiento: fechaSistema,
          numfactura: "",
          idalmacen: txtAlmacen.current.value,
          tipounidad: tipo,
          idunidadmedida: jsonData[i].idunidadmedida,
          idunidadalterna: jsonData[i].idunidadalterna,
          tipofactor: jsonData[i].tipofactor,
          valorfactor: jsonData[i].valorfactor,
          tasa: props.valormo,
          preciobs: round(jsonData[i].precioventa * props.valormo),
        });
      }
    }
    setBody({
      idtipopeinv: 1,
      opeinv: opeinv,
      opeinvdet: opeinvdet,
    });

    if (opeinv.length > 0 && opeinvdet.length > 0) {
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "Esta Segur@ de Procesar esta Operación de Inventario?",
        icono: "confirmacion",
      });
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "No hay Productos Incluidos",
        icono: "error",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const blanquear = () => {
    setActivate(false);
    setHabilitadoBot(true);
    setJsonData([]);
    setAlmacenData([]);
    setBody(null);
    seleccionarRegistros();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      setHabilitadoBot(false);
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      const selectedFile = "";
      setFile(selectedFile);
      blanquear();
    }
  };

  const cancelar = () => {
    blanquear();
    props.onHide();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  function esNumeroValido(valor) {
    // Si es un string vacío o solo espacios, no es un número
    if (typeof valor === 'string' && valor.trim() === '') return false;
    
    return !isNaN(parseFloat(valor)) && isFinite(valor);
}

  const convertToJson = async () => {
    if (!file) {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: "Por favor selecciona un archivo Excel.",
        icono: "informacion",
      });
      return;
    }

    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        const firstSheet = workbook.Sheets[workbook.SheetNames[0]];

        const jsonResult = XLSX.utils.sheet_to_json(firstSheet, {
          header: [
            "codigo",
            "nombrecorto",
            "precioventa",
            "cantidadc",
            "cantidadu",
            "unidadalterna",
          ],
          range: 1,
        });

        const requiredColumns = [
          "codigo",
          "nombrecorto",
          "precioventa",
          "cantidadc",
          "cantidadu",
          "unidadalterna",
        ];

        let noencontrado = [];
        if (jsonResult.length > 0) {
          const missingColumns = requiredColumns.filter(
            (col) => !Object.keys(jsonResult[0]).includes(col),
          );

          if (missingColumns.length > 0) {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: `Faltan columnas requeridas: ${missingColumns.join(", ")}`,
              icono: "error",
            });
            return;
          }
        }

        let enrichedData = [];

        for (let i = 0; i < jsonResult.length; i++) {
          const response = productosData.filter(
            (p) => p.codigo === jsonResult[i].codigo.toString(),
          );

          if (response && response.length > 0) {
            console.log(jsonResult[i].cantidadc);
            
            enrichedData.push({
              ...jsonResult[i],
              idproducto: response[0].idproducto,
              cantidad: esNumeroValido(jsonResult[i].cantidadc) ? jsonResult[i].cantidadc : 0,
              cantidadc: esNumeroValido(jsonResult[i].cantidadc) ? jsonResult[i].cantidadc : 0,
              cantidadu: esNumeroValido(jsonResult[i].cantidadu) ? jsonResult[i].cantidadu : 0,
              precioventa: esNumeroValido(jsonResult[i].precioventa) ? jsonResult[i].precioventa : 0,
              tipounidad: 0,
              idunidadmedida: response[0].idunidadmedida,
              idunidadalterna: response[0].idunidadalterna,
              tipofactor: parseFloat(response[0].valorfactor) > 1.0 ? "1" : "0",
              valorfactor: response[0].valorfactor,
            });
          } else {
            noencontrado.push(jsonResult[i].codigo);
          }
        }

        setJsonData(enrichedData);
        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto: `Archivo convertido. ${enrichedData.length} registros listos, y ${noencontrado.length} productos no se encontraron en la base de datos`,
          icono: "exito",
        });
      } catch (error) {
        setMensaje({
          mostrar: true,
          titulo: "Notificacion",
          texto: `Error al procesar el archivo: ${error.message}`,
          icono: "error",
        });
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const seleccionarProductos = async (codigo) => {
    let campos = "idproducto, idunidadmedida, idunidadalterna";
    let nomtab = "producto";
    let nomid = "codigo";
    let id = codigo;
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      });

      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        return response.data[0];
      }
      throw new Error("Producto no encontrado");
    } catch (error) {
      console.error(`Error buscando producto ${codigo}:`, error);
      throw error;
    }
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={async () => {
        await seleccionarRegistros();
        await seleccionarRegistrosProductos();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <Modal.Title style={{ color: "#fff" }}>
          Registro Existencia de Productos por Excel{" "}
        </Modal.Title>
        <button
          onClick={cancelar}
          ref={btnCancela}
          className="btn btn-sm text-light"
        >
          <i className="fas fa-share-square"> Salir</i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF" }}>
        <div style={{ height: "100%", width: "100%" }}>
          <div className="row col-md-12 " style={{ margin: 0 }}>
            <div className="row col-md-12 py-2" style={{ margin: 0 }}>
              <div className="col-pd-520">
                <div className="col-md-12 row m-0 mb-2 row m-0">
                  <input
                    type="file"
                    accept=".xlsx, .xls"
                    className="col-8"
                    onChange={handleFileChange}
                    style={{ marginBottom: "10px" }}
                  />
                  <button
                    disabled={!habilitadoBot}
                    ref={btnIncluir}
                    onClick={convertToJson}
                    className="btn btn-sm col-4 btn-success rounded-pill"
                    title="Carga la tabla con los productos"
                  >
                    <i className="fas fa-long-arrow-alt-down">
                      {" "}
                      Cargar Excel{" "}
                    </i>{" "}
                  </button>
                </div>
              </div>
              <div className="input-group input-group-sm mb-2 col-xl-6 col-lg-8 col-md-8 col-sm-12">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  ALMACEN:
                </label>
                <select
                  disabled={!habilitadoBot}
                  ref={txtAlmacen}
                  className="form-select form-select-sm "
                  aria-label=".form-select-sm example"
                >
                  {almacenData &&
                    almacenData.map((almacen) => (
                      <option key={almacen.idalmacen} value={almacen.idalmacen}>
                        {" "}
                        {almacen.descripcion}
                      </option>
                    ))}
                </select>
              </div>
              <div
                className="col-md-12 border-azul px-0 rounded"
                style={{ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 400,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden">
                    {jsonData &&
                      jsonData.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell
                            className="bg-light d-flex align-items-between px-0"
                            style={{ maxWidth: "200px" }}
                          >
                            {item.codigo}
                          </TableCell>
                          <TableCell
                            className={`align-middle bg-light text-start p-0 pl-2`}
                          >
                            {item.nombrecorto}
                          </TableCell>
                          <TableCell className="align-middle bg-light text-center p-0 col-pd-150">
                            <input
                              type="text"
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="precio"
                              disabled
                              defaultValue={formatMoneda(
                                item.precioventa
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                              ref={(el) => (txtPrecio.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={validarPrecio(index)}
                              onBlur={validarPrecio(index)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                          <TableCell className="align-middle bg-light text-center p-0 col-pd-150">
                            <input
                              type="text"
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="costo"
                              disabled={!habilitadoBot}
                              defaultValue={formatMoneda(
                                item.cantidadc
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                              ref={(el) => (txtCosto.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={validarCosto(index)}
                              onBlur={validarCosto(index)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                          <TableCell className="align-middle bg-light text-center p-0 col-pd-150">
                            <input
                              type="text"
                              className="form-control form-control-sm bg-light text-right fs-6"
                              id="precio"
                              disabled={!habilitadoBot}
                              defaultValue={formatMoneda(
                                item.cantidadu
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2,
                              )}
                              ref={(el) => (txtPrecio.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={validarPrecio(index)}
                              onBlur={validarPrecio(index)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                          <TableCell
                            className="align-middle bg-light text-center p-0"
                            style={{ width: "30px" }}
                          >
                            <button
                              disabled={!habilitadoBot}
                              onClick={eliminarProducto(item)}
                              className="btn btn-sm btn-danger"
                            >
                              <i className="fa fa-trash"></i>{" "}
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
              </div>
            </div>
          </div>
          <Dimmer active={activate} inverted>
            <Loader inverted>cargando...</Loader>
          </Dimmer>
          <Mensaje
            mensaje={mensaje}
            onHide={() =>
              mensaje.titulo === "Exito."
                ? blanquear()
                : setMensaje({
                    mostrar: false,
                    titulo: "",
                    texto: "",
                    icono: "",
                  })
            }
          />
          <MensajeSiNo
            mensaje={mensajesino}
            onHideNo={() =>
              setMensajesino({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              })
            }
            onHideSi={handleCloseSi}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="col-md-12 row mt-3">
          <div className="col-md-12 row m-0">
            <button
              disabled={!habilitadoBot}
              ref={btnIncluir}
              onClick={onBotones(5)}
              className="btn btn-sm col-2 btn-primary rounded-pill"
              title="Actualizar Precios"
            >
              <i className="fas fa-edit"> Actualizar </i>{" "}
            </button>
            <button
              ref={btnCancela}
              disabled={!habilitadoBot}
              onClick={onBotones(6)}
              className="btn btn-sm rounded-pill btn-danger col-2 ml-auto"
            >
              <i className="fas fa-window-close"> Cancelar</i>
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/almacen/modalOpeinveProductExcel.js